export function destructureFIO(fio: string) {
    if (fio.length) {
        const rawFio = fio.split(" ");
        return {
            firstName: rawFio[1] || "",
            middleName: rawFio[2] || "",
            lastName: rawFio[0] || "",
        };
    } else {
        return {
            firstName: "",
            middleName: "",
            lastName: "",
        };
    }
}
